import requestIp from 'request-ip'
import { ActionTree } from 'vuex'

export interface IStateIndex {}

export const actions: ActionTree<IStateIndex, any> = {
  async nuxtServerInit({ commit, dispatch }, { req, app, query }) {
    if (req && req.headers && req.headers.host) {
      commit('site/setHost', req.headers.host, { root: true })
    }

    const isShowAppBanner = app.$cookies.get('isShowAppBanner')
    if (isShowAppBanner === false || isShowAppBanner === 'false') {
      commit('site/setIsShowAppBanner', false)
    }

    if (query.partner) {
      commit('site/setHiddenCopyright', true, { root: true })
    }
    if (process.server) {
      const clientIp = requestIp.getClientIp(req)
      commit('site/setIP', clientIp || '', { root: true })
    }

    await dispatch('site/configLoad', { root: true, app })
  },
}
